<!-- =========================================================================================
    File Name: Listquestions.vue
    Description: Ag Grid table
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
    Author: Pixinvent
    Author URL: http://www.themeforest.net/question/pixinvent
========================================================================================== -->

<template>
  <div class="vx-card">
    <h4 class="pl-8 pt-6" v-if="title">{{ title }}</h4>
    <div class="p-8 pt-4">
      <div class="flex flex-wrap justify-between">
        <div class="flex">
          <vs-dropdown class="cursor-pointer" vs-trigger-click>
            <div
              class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium mr-2"
            >
              <span>
                {{ currentPage * paginationPageSize - (paginationPageSize - 1) }} -
                {{ questionData.length - currentPage * paginationPageSize > 0 ? currentPage * paginationPageSize : questionData.length }} of
                {{ totalQuestions }}</span
              >
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>

            <vs-dropdown-menu>
              <vs-dropdown-item
                @click="
                  gridApi.paginationSetPageSize(10);
                  loadProductBuffer();
                "
              >
                <span>10</span>
              </vs-dropdown-item>
              <vs-dropdown-item
                @click="
                  gridApi.paginationSetPageSize(20);
                  loadProductBuffer();
                "
              >
                <span>20</span>
              </vs-dropdown-item>
              <vs-dropdown-item
                @click="
                  gridApi.paginationSetPageSize(50);
                  loadProductBuffer();
                "
              >
                <span>50</span>
              </vs-dropdown-item>
              <vs-dropdown-item
                @click="
                  gridApi.paginationSetPageSize(100);
                  loadProductBuffer();
                "
              >
                <span>100</span>
              </vs-dropdown-item>
              <vs-dropdown-item
                @click="
                  gridApi.paginationSetPageSize(150);
                  loadProductBuffer();
                "
              >
                <span>150</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>

          <!--- <vs-button color="primary" class="ml-2 round" type="gradient"
                      @click="uploadQuestions">Upload Questions
           </vs-button> --->
        </div>

        <!-- TABLE ACTION COL-2: SEARCH & EXPORT AS CSV -->
        <div class="flex items-center">
          <vs-input
            @input="updateSearchQuery"
            class="sm:mr-4 mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4"
            placeholder="Search..."
            v-model="searchQuery"
          />
          <vs-button
            color="primary"
            icon-pack="feather"
            icon="icon-filter"
            class=""
            v-if="filterButton"
            type="gradient"
            @click="filterPopup = !filterPopup"
            >Open Filter
          </vs-button>
        </div>
      </div>

      <!-- AgGrid Table -->
      <ag-grid-vue
        :animateRows="true"
        :columnDefs="columnDefs"
        :components="components"
        :defaultColDef="defaultColDef"
        :enableRtl="$vs.rtl"
        :floatingFilter="true"
        :gridOptions="gridOptions"
        :pagination="true"
        :paginationPageSize="paginationPageSize"
        :rowData="questionData"
        :suppressPaginationPanel="true"
        class="ag-theme-material w-100 my-4 ag-grid-table"
        colResizeDefault="shift"
        ref="agGridTable"
      >
      </ag-grid-vue>
      <vs-pagination :total="totalPages" v-model="currentPage" />
    </div>
  </div>
</template>

<script>
import TableActions from './components/TableActions.vue'
import TableCopy from './components/TableCopy'
import TableImage from './components/TableImage'
import { AgGridVue } from 'ag-grid-vue'
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
import vSelect from 'vue-select'

export default {
  components: {
    AgGridVue,
    vSelect,
    TableActions,
    TableCopy,
    TableImage
  },
  props: {
    title: {
      type: String,
      default: '',
      required: false
    },
    filterButton: {
      type: Boolean,
      default: true,
      required: false
    },
    filterSets: {
      type: Boolean,
      default: true,
      required: false
    },
    setId: {
      type: String,
      default: '',
      required: false
    },
    bankId: {
      type: String,
      default: '',
      required: false
    }
  },
  data () {
    return {
      showArchived: false,

      questionData: [],
      totalQuestions: 0,

      pageValue: 0,

      searchQuery: '',

      filterPopup: false,

      // AgGrid
      gridApi: null,
      gridOptions: {},
      defaultColDef: {
        sortable: true,
        resizable: true,
        suppressMenu: true,
        valueFormatter: (params) => {
          if (typeof params.value === 'string') {
            const value = params.value
            return value.charAt(0).toUpperCase() + value.slice(1)
          }

          return params
        }
      },

      columnDefs: [
        {
          headerName: 'ID',
          field: 'id',
          filter: true,
          width: 250,
          cellRendererFramework: 'TableCopy'
        },
        {
          headerName: 'Type',
          field: 'type',
          filter: true,
          width: 300,
          cellRendererFramework: 'TableCopy'
        },
        {
          headerName: 'Question',
          field: 'question',
          filter: true,
          width: 300,
          cellRendererFramework: 'TableCopy'
        },
        {
          headerName: '',
          field: 'image',
          width: 100,
          filter: false,
          cellRendererFramework: 'TableImage'
        },
        {
          headerName: 'Actions',
          width: 150,
          sortable: false,
          cellRendererFramework: 'TableActions',
          cellRendererParams: {
            loadProductBuffer: this.loadProductBuffer.bind(this)
          }
        }
      ],

      // Cell Renderer Components
      components: {
        TableActions,
        TableCopy,
        TableImage
      },
      totalPages: 0
    }
  },
  computed: {
    paginationPageSize () {
      if (this.gridApi) return this.gridApi.paginationGetPageSize()
      else return 10
    },
    currentPage: {
      get () {
        return this.pageValue + 1
      },
      set (val) {
        this.pageValue = val - 1
        this.loadProductBuffer(val)
      }
    }
  },
  methods: {
    uploadQuestions () {
      this.$router.push('/a/examedge/questions/upload')
    },
    setColumnFilter (column, val) {
      const filter = this.gridApi.getFilterInstance(column)
      let modelObj = null

      if (val !== 'all') {
        modelObj = { type: 'equals', filter: val }
      }

      filter.setModel(modelObj)
      this.gridApi.onFilterChanged()
    },
    updateSearchQuery () {
      this.currentPage = 0
    },
    loadProductBuffer (page = 0) {
      this.$emit('refresh_data')

      if (page === 0) {
        page = this.currentPage
      }

      this.gridApi.setId = this.setId
      this.gridApi.bankId = this.bankId

      this.$http
        .get(`testprep/questions/count?amount=${this.paginationPageSize}&search=${this.searchQuery}&set=${this.setId}&bank=${this.bankId}`)
        .then((response) => {
          if (response.data.data) {
            const data = response.data.data

            if (data.pages) {
              this.totalPages = data.pages
              this.totalQuestions = data.total
            }
          }
        })
        .catch(() => {})

      this.$http
        .get(
          `testprep/questions?amount=${this.paginationPageSize}&page=${page}&archived=${this.showArchived}&search=${this.searchQuery}&set=${this.setId}&bank=${this.bankId}`,
        )
        .then((response) => {
          if (response.data.data) {
            this.questionData = response.data.data
          }

          this.questionData = this.questionData.map((question) => {
            question.name = `${question.first_name} ${question.last_name}`
            const pictureId = question.profile_picture || 'default'
            question.photoURL = `https://portal-cdn.rapid.education/profile-pictures/${pictureId}.jpeg`
            return question
          })

          this.gridApi.sizeColumnsToFit()
        })
        .catch((exception) => {
          let error = 'An unknown error occurred while loading the question course-classroom-list'
          if (exception.response) {
            error = exception.response.data.error.description
          }

          return this.$vs.notify({
            title: 'Failed to load question course-classroom-list',
            text: error,
            color: 'danger',
            position: 'top-right'
          })
        })
    }
  },
  mounted () {
    this.gridApi = this.gridOptions.api
    if (this.$vs.rtl) {
      const header = this.$refs.agGridTable.$el.querySelector('.ag-header-container')
      header.style.left = `-${String(Number(header.style.transform.slice(11, -3)) + 9)}px`
    }
  }
}
</script>
<style lang="scss">
.theme-dusk {
  #QuestionFilterPopup {
    input.vs-inputx.vs-input--input {
      background: #050056 !important;
      border: 1px solid #ffffff !important;

      &:focus {
        border: 1px solid rgba(var(--vs-primary), 1) !important;
      }
    }
  }

  #RegQuestionPopup {
    input.vs-inputx.vs-input--input {
      background: #050056 !important;
      border: 1px solid #ffffff !important;

      &:focus {
        border: 1px solid rgba(var(--vs-primary), 1) !important;
      }
    }

    .vs-component.vs-con-textarea.vs-textarea-primary {
      background: #050056 !important;
      border: 1px solid #ffffff !important;

      &:focus {
        border: 1px solid rgba(var(--vs-primary), 1) !important;
      }
    }
  }
}

.theme-dark {
  #QuestionFilterPopup {
    input.vs-inputx.vs-input--input {
      background: #1b1e22 !important;
      border: 1px solid #ffffff !important;

      &:focus {
        border: 1px solid rgba(var(--vs-primary), 1) !important;
      }
    }
  }

  #RegQuestionPopup {
    input.vs-inputx.vs-input--input {
      background: #1b1e22 !important;
      border: 1px solid #ffffff !important;

      &:focus {
        border: 1px solid rgba(var(--vs-primary), 1) !important;
      }
    }

    .vs-component.vs-con-textarea.vs-textarea-primary {
      background: #1b1e22 !important;
      border: 1px solid #ffffff !important;

      &:focus {
        border: 1px solid rgba(var(--vs-primary), 1) !important;
      }
    }
  }
}
</style>
